/**
 * Pre-compiled en messages for TagGroup
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { removeTag: `Remove tag` };
